module.exports = __webpack_public_path__ + "img/a56f591.png";